import React from "react";
import { Truck, MapPin, Package, RotateCcw } from "lucide-react";

export default function ShippingPage() {
  return (
    <div data-testid="shipping-page" className="max-w-3xl mx-auto px-4 sm:px-8 py-16">
      <div className="text-xs tracking-[0.25em] uppercase font-mono text-yellow-400 mb-3">
        // Shipping &amp; pickup
      </div>
      <h1 className="font-[Outfit] text-4xl sm:text-5xl font-black tracking-tighter">
        How your order gets to you.
      </h1>
      <p className="mt-4 text-slate-400 max-w-2xl">
        We ship Pokémon TCG orders out of Alberta, Canada. Pick the option that
        works for you at checkout.
      </p>

      <div className="mt-10 space-y-8">
        <PolicySection icon={<Truck />} title="Tracked shipping — $15 CAD flat">
          <p>
            One flat <strong className="text-white">$15 CAD</strong> covers tracked
            Canada Post delivery anywhere in Canada. Most orders go out within
            1–3 business days of payment clearing. Higher-value orders ship with
            signature &amp; insurance included.
          </p>
        </PolicySection>

        <PolicySection icon={<MapPin />} title="Free local pickup">
          <p>
            Meet us at any of our upcoming shows across Alberta — no shipping fee.
            Check the <a href="/shows" className="text-yellow-400 hover:text-yellow-300">Shows</a>{" "}
            page for upcoming dates. We&apos;ll confirm your pickup when we email
            you back about your order.
          </p>
        </PolicySection>

        <PolicySection icon={<Package />} title="Where we ship from">
          <p>
            Based in <strong className="text-white">Alberta, Canada</strong>.
            Currently shipping within Canada only — international shipping is
            coming soon. Need an international quote? Message us before you
            check out.
          </p>
        </PolicySection>

        <PolicySection icon={<RotateCcw />} title="Refunds &amp; damages">
          <p>
            If a sealed product or slab arrives damaged, send photos within
            48 hours of delivery and we&apos;ll work it out. All sales are final
            once marked delivered.
          </p>
        </PolicySection>
      </div>
    </div>
  );
}

function PolicySection({ icon, title, children }) {
  return (
    <div className="border-l-2 border-yellow-400 pl-5">
      <div className="flex items-center gap-2 text-white font-bold text-lg mb-2">
        <span className="text-yellow-400">{icon}</span>
        {title}
      </div>
      <div className="text-slate-300 leading-relaxed">{children}</div>
    </div>
  );
}
